import useUtility from "@/app/_hooks/useUtility";
import { frontendImage, shortDescription, showDateTime } from "@/lib/helpers";
import Image from "next/image";
import Link from "next/link";

export const BlogItem = ({ blog }) => {
    const { trans } = useUtility()
    const slug = blog.data_values.title
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, ""); // Convert title to slug

    return (
        <div className="blog-item">
            <Link
                href={`/blogs/${blog.id}/${slug}`}
                className="blog-item__thumb d-block"
            >
                {blog?.data_values?.image?.includes(
                    ".mp4"
                ) ? (
                    <video
                        src={`${process.env.NEXT_PUBLIC_API_URL}/assets/images/frontend/blog/${blog?.data_values?.image}`}
                        height="100%"
                        width="100%"
                        autoPlay
                        loop
                        muted
                    ></video>
                ) : (
                    <Image
                        src={`${process.env.NEXT_PUBLIC_API_URL}/assets/images/frontend/blog/${blog?.data_values?.image}`}
                        alt={blog?.data_values?.title}
                        width={600}
                        height={430}
                    />
                )}
            </Link>
            <div className="blog-item__content">
                <span className="blog-item__tag">{trans(blog?.data_values?.category)}</span>
                <h6 className="blog-item__title">
                    <Link href={`/blogs/${blog.id}/${slug}`} className="blog-item__link">
                        {shortDescription(blog?.data_values?.title, 53)}
                    </Link>
                </h6>
                <div className="blog-item__bottom">
                    <div className="blog-item__author">
                        <span className="blog-item__author-thumb">
                            <Image
                                src={frontendImage(blog?.data_values?.author_image, "blog")}
                                alt="author"
                                width={36}
                                height={36}
                            />
                        </span>
                        <span className="blog-item__author-name">{blog?.data_values?.author}</span>
                    </div>
                    <span className="blog-item__date">{showDateTime(blog?.created_at, 'MMMM d, YYYY')}</span>
                </div>
            </div>
        </div>
    );
};